import styled, { css } from 'styled-components';

export const TimeslotsScroll = styled.div<{$isScrollable?: boolean }>`
	overflow-y: hidden;
	overflow-x: hidden;

	${props => props.$isScrollable && css`
		overflow-x: scroll;
	`}

	display: flex;
	gap: 8px;
	padding: 25px 0px 10px 0px;
	scroll-behavior: smooth;

	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const PreloaderContainer = styled.div`
	margin-top: -10px;
`;
